import { render, staticRenderFns } from "./ItemForList.vue?vue&type=template&id=32697f5f&scoped=true"
import script from "./ItemForList.vue?vue&type=script&lang=ts"
export * from "./ItemForList.vue?vue&type=script&lang=ts"
import style0 from "./ItemForList.vue?vue&type=style&index=0&id=32697f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32697f5f",
  null
  
)

export default component.exports